import { optionalString } from './search-params'

/**
 * The Renders surface's URL state. Rooms, concepts and views are places that
 * can be linked to and returned to with Back rather than transient component
 * state.
 */
/** `?view=` sentinel for the start row of a room that already has views. */
export const NEW_VIEW = 'new'

export type RendersSearch = {
  /** Which render concept is open when a room has more than one. */
  concept?: string
  /** Which room is open. Absent = the selected concept's room or the first room. */
  room?: string
  /**
   * Which view's timeline is open. Absent = the room's first view;
   * `NEW_VIEW` = the add-view start row.
   */
  view?: string
}

/**
 * A deleted concept cannot remain as URL state. When it was the room's last
 * concept, the room cannot remain selected either: the board will fall back
 * to another room, and the URL must describe that same fallback.
 */
export const searchAfterConceptRemoval = (
  search: RendersSearch,
  lastConceptInRoom: boolean
): RendersSearch => ({
  ...search,
  concept: undefined,
  room: lastConceptInRoom ? undefined : search.room,
  view: undefined,
})

export const decodeRendersSearch = (search: Record<string, unknown>): RendersSearch => ({
  // Convex exposes table-aware ID normalization only inside functions via
  // `ctx.db.normalizeId`. Keep URL selectors as untrusted strings here; the
  // query normalizes the values it consumes before using them as IDs.
  concept: optionalString(search.concept),
  room: optionalString(search.room),
  view: optionalString(search.view),
})
